import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BrokeFlexMessageService } from '../services/BrokeFlexMessageService'
import { BROKE_FLEX_MESSAGE_KEYS } from '../../keys'

interface UseMutationAddStageOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

export default function useMutationAddStage({
	onSuccess,
	onError,
}: UseMutationAddStageOptions = {}) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			campaignId,
			dto,
		}: {
			campaignId: string
			dto: {
				minutesAfter: number
				message: string
				type: 'PROMOTION' | 'COUPON' | 'INSTANT_CREDIT'
				promotionId?: string
				couponCode?: string
			}
		}) => BrokeFlexMessageService.addStage(campaignId, dto),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: BROKE_FLEX_MESSAGE_KEYS.ALL,
			})
			onSuccess?.()
		},
		onError,
	})
}
